// Google Ads purchase conversions (tag AW-1007826947, public/index.html), one place for every product.
//
// Stripe sends a buyer back with only an order id (/thank-you?order=…) or a Checkout Session id
// (/thank-you?session_id=…), so the amount is remembered just before the buyer leaves for Stripe and
// looked up on return. Each order is reported once, with transaction_id = that id (Google Ads also drops
// duplicates of the same transaction id), and only on a real return from a payment: a bare /thank-you
// visit, a reload or a second tab report nothing. The Venus reading keeps its own report
// (VenusReadingThankYouPage), which already sends the real value once per order.
const SEND_TO = 'AW-1007826947/N1hYCLKL-scbEIPwyOAD';
// Free calendar sign-ups have their own action, "Calendar sign-up Ivy", a flat €1 set in Google Ads (scripts/google-ads/signup-conversion.mjs).
const SIGNUP_SEND_TO = 'AW-1007826947/t2s6CLXfxq8dEIPwyOAD';
const PENDING_KEY = 'ivy-pending-purchases'; // { [transactionId]: { value, currency, at } }
const SENT_KEY = 'ivy-ads-conversions-sent'; // [transactionId, …]

const read = (key, fallback) => {
  try {
    const v = JSON.parse(localStorage.getItem(key));
    return v == null ? fallback : v;
  } catch {
    return fallback;
  }
};
const write = (key, value) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // private mode or storage full: the conversion is then reported without a value
  }
};

/** Before the redirect to Stripe: the amount (in euros, not cents) this order or session will be paid at. */
export function rememberPurchase(transactionId, value, currency = 'EUR') {
  const amount = Number(value);
  if (!transactionId || !(amount > 0)) return;
  const pending = read(PENDING_KEY, {});
  pending[transactionId] = { value: Math.round(amount * 100) / 100, currency: String(currency || 'EUR').toUpperCase(), at: Date.now() };
  const newest = Object.keys(pending).sort((a, b) => pending[b].at - pending[a].at).slice(0, 20);
  write(PENDING_KEY, Object.fromEntries(newest.map((k) => [k, pending[k]])));
}

/** On the thank-you page: reports the purchase once. Returns true when it was sent now. */
export function sendPurchaseConversion(transactionId) {
  if (!transactionId || typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
  const sent = read(SENT_KEY, []);
  if (sent.includes(transactionId)) return false;
  const known = read(PENDING_KEY, {})[transactionId];
  window.gtag('event', 'conversion', {
    send_to: SEND_TO,
    transaction_id: transactionId,
    // no remembered amount (another device, cleared storage): Google Ads uses the action's default value
    ...(known ? { value: known.value, currency: known.currency } : {}),
  });
  write(SENT_KEY, [...sent, transactionId].slice(-50));
  return true;
}

/** Right after a calendar account is created, which happens once per person. Returns true when it was sent. */
export function sendSignupConversion() {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return false;
  window.gtag('event', 'conversion', { send_to: SIGNUP_SEND_TO });
  return true;
}
